
import React, { useState,useEffect } from "react";

import Chart from "chart.js";

import {
  Container,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";

import ChartLine from "../components/comp/ChartLine"
import ChartBar from "../components/comp/ChartBar"
import TableComp from "../components/comp/TableComp"
import TableProgress from "components/comp/TableProgress"
import {
  chartOptions,
  parseOptions,
} from "variables/charts.js";

import Header from "components/Headers/Header.js";

const Index = (props) => {


  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }
  const [users, setData] = useState([]);
  const [courses, setCourses] = useState([]);

  useEffect(async () => {
    const response = await axios.get(
         "http://mimapp.mimshakup.com/api/teachers/get-courses"
    );
    setCourses(response.data);
    }, [])

  useEffect(async () => {
    const response = await axios.get(
         "http://mimapp.mimshakup.com/api/teachers/get-students"
    );
    setData(response.data);
    }, [])
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>

        <Row >
          <Col className="mb-5 mb-xl-0" xl="6">
            <TableComp data={courses} user={false}/>
          </Col>
          <Col className="mb-5 mb-xl-0" xl="6">
            <TableComp data={users} user={true}/>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
              <ChartLine />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Index;
